import styled from 'styled-components';
import { textColor, THEME_BLACK, THEME_PRIMARY, THEME_SILVER } from '../../../styles/basics/colors';
import ModalLayout from './ModalLayout';
import { ModalButtonLine } from './ModalButtonLine';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const StButton = styled.a`
    font-size: 14px;
    margin-left: 20px;
    color: ${textColor(THEME_PRIMARY)};

    &:hover {
        ${textColor(THEME_SILVER)};
    }

    text-transform: uppercase;
`;

const StCancelButton = styled(StButton)`
    font-weight: 400;
`;

export const StHeader = styled.h4`
    color: ${textColor(THEME_BLACK)};
    margin-bottom: 20px;
    margin-right: 40px;
    font-weight: bold;
    line-height: 26px;
    word-wrap: break-word;
`;

const StContent = styled.p`
    font-size: 18px;
`;

export const StModalButtonLine = styled(ModalButtonLine)`
    margin-top: 60px;
`;

interface Props {
    visible: boolean;
    title: string;
    onConfirm: () => void;
    onCancel: () => void;
    text?: string;
}

const ConfirmationModalLayout: FC<Props> = ({ visible, title, onConfirm, onCancel, text }) => {
    const { t } = useTranslation();
    const header = <StHeader>{title}</StHeader>;
    const content = !text ? null : <StContent dangerouslySetInnerHTML={{ __html: text }} />;

    const confirmationButton = (
        <StButton data-displayname="ConfirmationButton" onClick={onConfirm}>
            {t('confirm')}
        </StButton>
    );
    const cancelButton = <StCancelButton onClick={onCancel}>{t('cancel')}</StCancelButton>;

    const footer = (
        <StModalButtonLine>
            {confirmationButton}
            {cancelButton}
        </StModalButtonLine>
    );

    return (
        <ModalLayout
            header={header}
            content={content}
            footer={footer}
            visible={visible}
            width={530}
            closable={false}
            closeOnEsc={false}
        />
    );
};

export default ConfirmationModalLayout;
